import { PostMessageClient } from '@reachmedianetwork/post-message-client';
import {
    PlatformMessage,
    PlatformOutboundPostMessageClient,
} from '@reachmedianetwork/post-message-client-rds-api';
import { timeout } from '../../Utility/Timeout';

const MESSAGES_TIMEOUT_SECONDS = 15;

let pmsgClientInstance: SignsMessenger | undefined;

export class SignsMessenger {
    client: PlatformOutboundPostMessageClient;
    #supportedMessages: Array<string>;

    constructor(client: PlatformOutboundPostMessageClient, supportedMessages: Array<string>) {
        this.client = client;
        this.#supportedMessages = supportedMessages;
    }

    supports(msgType: string): boolean {
        return this.#supportedMessages.includes(msgType);
    }
}

export async function createSignsPostMessageClient(targetWindow: Window): Promise<SignsMessenger> {
    if (pmsgClientInstance === undefined) {
        const pmsgClient: PlatformOutboundPostMessageClient = new PostMessageClient(targetWindow);

        const supportedMessages = await timeout(
            pmsgClient.postMessage(PlatformMessage.MessagesGet, undefined),
            MESSAGES_TIMEOUT_SECONDS * 1000
        );
        // just in case an other promise resolved
        if (pmsgClientInstance === undefined) {
            pmsgClientInstance = new SignsMessenger(pmsgClient, supportedMessages);
        }
    }
    return pmsgClientInstance;
}
